module.exports = __webpack_public_path__ + "img/two2Orange.8306bdfc.jpg";